function cov_z0bf41xkr() {
  var path = "/app/src/hooks/use-next-billing-date.ts";
  var hash = "2f0405ea099c9b05f6a8c5909b48d75fe3598474";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-next-billing-date.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 34
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 21
        }
      },
      "2": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 29
        }
      },
      "3": {
        start: {
          line: 12,
          column: 17
        },
        end: {
          line: 12,
          column: 29
        }
      },
      "4": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 52
        }
      },
      "5": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "6": {
        start: {
          line: 16,
          column: 33
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "7": {
        start: {
          line: 18,
          column: 14
        },
        end: {
          line: 18,
          column: 77
        }
      },
      "8": {
        start: {
          line: 19,
          column: 16
        },
        end: {
          line: 21,
          column: 4
        }
      },
      "9": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 6,
            column: 35
          }
        },
        loc: {
          start: {
            line: 6,
            column: 40
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 29
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 45
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2f0405ea099c9b05f6a8c5909b48d75fe3598474"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_z0bf41xkr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_z0bf41xkr();
import { useAppContext } from 'src/context/store/app-provider';
import { Locale } from 'src/types/lang-locale-type';
import { getLocale } from 'src/utils/get-locale';
import { isValidDate } from 'src/utils/is-valid-date';
cov_z0bf41xkr().s[0]++;
export var useNextBillingDate = function useNextBillingDate() {
  cov_z0bf41xkr().f[0]++;
  var _ref = (cov_z0bf41xkr().s[1]++, useAppContext()),
    lang = _ref.lang,
    payLater = _ref.offers.payLater;
  cov_z0bf41xkr().s[2]++;
  if (!payLater) {
    cov_z0bf41xkr().b[0][0]++;
    cov_z0bf41xkr().s[3]++;
    return null;
  } else {
    cov_z0bf41xkr().b[0][1]++;
  }
  var billingDate = (cov_z0bf41xkr().s[4]++, new Date(payLater.paymentDate));
  cov_z0bf41xkr().s[5]++;
  if (!isValidDate(billingDate)) {
    cov_z0bf41xkr().b[1][0]++;
    cov_z0bf41xkr().s[6]++;
    return null;
  } else {
    cov_z0bf41xkr().b[1][1]++;
  }
  var day = (cov_z0bf41xkr().s[7]++, billingDate.toLocaleString(Locale['en-US'], {
    day: 'numeric'
  }));
  var month = (cov_z0bf41xkr().s[8]++, billingDate.toLocaleString(getLocale(lang), {
    month: 'short'
  }));
  cov_z0bf41xkr().s[9]++;
  return {
    day: day,
    month: month
  };
};